/**
 * Районы, доступные этому домену и этой организации — глазами разделов с картой.
 *
 * Ключ запроса тот же, что у списка видов (`['cabinet','species']`): районы
 * едут ТЕМ ЖЕ ответом, и второй поход на сервер завёл бы состояние «виды
 * приехали, районы ещё нет», в котором карте нечего открывать.
 *
 * Три ответа разделу: чем открыть карту (`home`), решено ли это уже (`known`) и
 * не отказал ли сервер в районах вовсе (`forbidden`).
 */

import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'

import { cabinetApi, type RegionItem } from '../api'
import type { MapView } from '../map/mapView'
import { homeView } from './regionHome'
import { isRegionForbidden } from './regionScope'

export interface RegionScopeState {
  /** Эффективный набор в порядке справочника; первый — район входа. */
  regions: RegionItem[]
  /** Вид карты по рамке первого района; `null` — набора нет. */
  home: MapView | null
  /** Сервер ответил (набором или отказом) — карту можно строить. */
  known: boolean
  /** Пересечение пусто: домен и права организации не сошлись ни на одном районе. */
  forbidden: boolean
}

export function useRegionScope(): RegionScopeState {
  const { data, error, isSuccess, isError } = useQuery({
    queryKey: ['cabinet', 'species'],
    queryFn: () => cabinetApi.species(),
  })
  return useMemo(() => {
    const regions = data?.regions ?? []
    return {
      regions,
      home: homeView(regions),
      // Отказ — тоже ответ: карту после него держать серым местом нельзя,
      // человек должен увидеть плашку, а не пустой раздел.
      known: isSuccess || isError,
      forbidden: isRegionForbidden(error),
    }
  }, [data, error, isSuccess, isError])
}
